import isDesktop from '@lib/is-desktop';
import once from '@lib/once';

function getWindowScroll() {
    return window.scrollY || window.pageYOffset;
}

function initHeaderContainer(headerContainer) {
    let previousScrollPosition = getWindowScroll();
    let minimumScrollPositionToHide = isDesktop() ? 130 : 80;
    let ignoreScroll = false;

    headerContainer.addEventListener('header-container:show', show);
    headerContainer.addEventListener('header-container:hide', hide);
    headerContainer.addEventListener('header-container:sticky', stick);
    headerContainer.addEventListener('header-container:unsticky', unstick);
    headerContainer.addEventListener('header-container:pause', stopScrollingListener);
    headerContainer.addEventListener('header-container:resume', resumeScrollingListener);

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });

    function emitEvent(name) {
        headerContainer.dispatchEvent(new Event('header-container:' + name));
    }

    function show() {
        headerContainer.classList.remove('is-hidden');
    }

    function hide() {
        headerContainer.classList.add('is-hidden');
    }

    function stick() {
        headerContainer.classList.add('is-fixed');
    }

    function unstick() {
        headerContainer.classList.remove('is-fixed');
    }

    function onScroll() {
        if (ignoreScroll) return;

        const currentScrollPosition = getWindowScroll();

        if (currentScrollPosition === 0) {
            headerContainer.classList.remove('is-fixed');
            emitEvent('unsticky');
        }

        if (currentScrollPosition < minimumScrollPositionToHide) {
            emitEvent('show');
        } else {
            emitEvent('sticky');

            if (previousScrollPosition < currentScrollPosition) {
                emitEvent('hide');
            } else {
                emitEvent('show');
            }
        }

        previousScrollPosition = currentScrollPosition;
    }

    function onResize() {
        minimumScrollPositionToHide = isDesktop() ? 130 : 80;
    }

    function stopScrollingListener() {
        ignoreScroll = true;
        emitEvent('show');
        emitEvent('unsticky');
    }

    function resumeScrollingListener() {
        ignoreScroll = false;
        if (getWindowScroll() > minimumScrollPositionToHide) {
            emitEvent('sticky');
            emitEvent('hide');
        } else {
            emitEvent('show');
            emitEvent('unsticky');
        }
    }
}

window.Drupal.behaviors.headerContainer = {
    attach: function (context) {
        const headerContainer = context.querySelector('#header-container');
        once('headerContainer', () => initHeaderContainer(headerContainer), [headerContainer]);
    },
};
